// Page Header
export const CouponLandingPageService_GetHeaderLazy = () =>
  import("./service.grpc").then((m) => m.CouponLandingPageService_GetHeader);
CouponLandingPageService_GetHeaderLazy.method =
  "aysa_api.services.coupons.v1.landingpage.CouponLandingPageService/GetHeader" as const;

// Category Navigation
export const CouponLandingPageService_GetCategoryNavigationLazy = () =>
  import("./service.grpc").then(
    (m) => m.CouponLandingPageService_GetCategoryNavigation
  );
CouponLandingPageService_GetCategoryNavigationLazy.method =
  "aysa_api.services.coupons.v1.landingpage.CouponLandingPageService/GetCategoryNavigation" as const;

// Category Tree Navigation (for Web Desktop)
export const CouponLandingPageService_GetCategoryTreeNavigationLazy = () =>
  import("./service.grpc").then(
    (m) => m.CouponLandingPageService_GetCategoryTreeNavigation
  );
CouponLandingPageService_GetCategoryTreeNavigationLazy.method =
  "aysa_api.services.coupons.v1.landingpage.CouponLandingPageService/GetCategoryTreeNavigation" as const;

// Filters
export const CouponLandingPageService_GetFiltersLazy = () =>
  import("./service.grpc").then((m) => m.CouponLandingPageService_GetFilters);
CouponLandingPageService_GetFiltersLazy.method =
  "aysa_api.services.coupons.v1.landingpage.CouponLandingPageService/GetFilters" as const;

// Page Stream
export const CouponLandingPageService_GetStreamLazy = () =>
  import("./service.grpc").then((m) => m.CouponLandingPageService_GetStream);
CouponLandingPageService_GetStreamLazy.method =
  "aysa_api.services.coupons.v1.landingpage.CouponLandingPageService/GetStream" as const;

// Gender Switch
export const CouponLandingPageService_GetGenderSwitchLazy = () =>
  import("./service.grpc").then(
    (m) => m.CouponLandingPageService_GetGenderSwitch
  );
CouponLandingPageService_GetGenderSwitchLazy.method =
  "aysa_api.services.coupons.v1.landingpage.CouponLandingPageService/GetGenderSwitch" as const;

// GetNavigation returns the navigation section: categories label and popular filters (for App and mWeb)
export const CouponLandingPageService_GetNavigationLazy = () =>
  import("./service.grpc").then(
    (m) => m.CouponLandingPageService_GetNavigation
  );
CouponLandingPageService_GetNavigationLazy.method =
  "aysa_api.services.coupons.v1.landingpage.CouponLandingPageService/GetNavigation" as const;

// GetNavigationSectionCategories returns the full category tree (for App and mWeb)
export const CouponLandingPageService_GetNavigationSectionCategoriesLazy = () =>
  import("./service.grpc").then(
    (m) => m.CouponLandingPageService_GetNavigationSectionCategories
  );
CouponLandingPageService_GetNavigationSectionCategoriesLazy.method =
  "aysa_api.services.coupons.v1.landingpage.CouponLandingPageService/GetNavigationSectionCategories" as const;
